import React from "react"
import styled from "styled-components"
import { setRem, setColor, media } from "../../style"
import imgStars from "../../images/trust/Star_rating_4_5_of_5_png_of_5.webp"
import Container from "@material-ui/core/Container"
import { FormattedMessage, FormattedHTMLMessage } from "gatsby-plugin-intl"

const SeeWhyOur = () => {
  return (
    <Contain maxWidth="lg">
      <h2>
        <FormattedHTMLMessage id="home.seeWhyOur.seeWhy" />
      </h2>
      <section className="rating-elements">
        <div>
          <div className="overall">
            <FormattedMessage id="home.seeWhyOur.overallRating" />
          </div>
          <img src={imgStars} alt="Overall Rating" />
          <div className="reviews">
            *<FormattedMessage id="home.seeWhyOur.fromOurReviews" />
          </div>
        </div>

        <div className="rating-box">
          <div className="rating">4.6</div>
          <div className="out-off">
            <FormattedHTMLMessage id="home.seeWhyOur.outOff" /> 5.0
          </div>
        </div>
        <div className="of-our">
          <div className="percent">90%</div>
          <FormattedMessage id="home.seeWhyOur.ofCustomers" />
        </div>
      </section>
    </Contain>
  )
}

export default SeeWhyOur

const Contain = styled(Container)`
  margin: 2rem auto 3rem;

  h2 {
    font-size: ${setRem(34)};
    font-weight: normal;
    text-align: center;
  }
  b {
    color: ${setColor.primaryColor};
  }
  .rating-elements {
    margin: 3rem auto;
    width: 100%;
    display: grid;
    align-items: center;
    justify-items: center;
    grid-template-columns: 1fr 1fr;

    grid-column-gap: 3rem;
    grid-row-gap: 4rem;
    ${media.tablet`
      grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: 1fr;
        grid-column-gap: 4rem;
    `}
  }
  .overall {
    font-size: ${setRem(20)};
    font-weight: bold;
    margin-bottom: 0.3rem;
  }
  .reviews {
    font-size: ${setRem(12)};
    color: ${setColor.primaryColor};
    margin-top: ${setRem(4)};
  }
  .rating-box {
    border-right: 1px solid rgba(42, 42, 42, 1);
    border-bottom: 1px solid rgba(42, 42, 42, 1);
    border-radius: 0;
    text-align: center;
    color: ${setColor.mainWhite};
  }
  .rating {
    width: ${setRem(118)};
    height: ${setRem(91)};

    background-color: rgba(115, 201, 234, 1);
    font-size: ${setRem(49)};
    font-weight: bold;

    padding: 1rem;
  }
  .out-off {
    background-color: rgba(55, 59, 77, 1);
    font-size: ${setRem(15)};
    padding: 0.3rem;
  }
  .of-our {
    text-align: center;
    font-size: ${setRem(15)};
    color: #373b4d;
    width: ${setRem(157)};
  }
  .percent {
    font-size: ${setRem(49)};
    font-weight: bold;
  }
`
